export const getIsAllFielsEmpty = (formValues: object) => {
	const areAllFieldsEmpties = Object.values(formValues).every(
		(value) => value === '' || value === undefined || value === null
	);
	return areAllFieldsEmpties;
};

export const getIsFormFilled = (formValues: object) => {
	const areAllFieldsFilled =
		Object.values(formValues).length > 0 &&
		Object.values(formValues).every(
			(value) => value !== '' && value !== undefined && value !== null
		);
	return areAllFieldsFilled;
};

export const areArraysDifferent = (arr1: string[], arr2: string[]) => {
	if (!arr1 || !arr2) return;

	if (arr1.length !== arr2.length) {
		return true;
	}

	const sortedArray1 = arr1.slice().sort();
	const sortedArray2 = arr2.slice().sort();

	for (let i = 0; i < sortedArray1.length; i++) {
		if (sortedArray1[i] !== sortedArray2[i]) {
			return true;
		}
	}
	return false;
};
